export const user = state => state.authCustom.user
export const session = state => state.authCustom.session
export const tokens = state => state.authCustom.loginTokenExchangeSuccess
export const sessionDetails = state => state.authCustom.getSessionUserSuccess
